import { tkHost } from '../../../../../settings';
import type { ArticleData } from '../types';

export const articles: ArticleData = {
	BDS: {
		categoryLink: `${tkHost}/content/wedding-music-advice`,
		articles: [
			{
				srcId: '9d4327e0-5305-4877-a5c9-c85a6135c5d8',
				title: 'Should You Have a Band or DJ for Your Wedding Reception Music?',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding reception Band and DJ',
				href: `${tkHost}/content/wedding-reception-music-bands-vs-djs`,
			},
			{
				srcId: '9d15ff84-dbe5-40ee-898a-70e909906771',
				title: '22 Questions to Ask Your Wedding Band or DJ',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding band performs at reception',
				href: `${tkHost}/content/wedding-reception-music-questions-to-ask-a-band`,
			},
			{
				srcId: 'e447c6f8-a135-4ba1-bab5-1c17e9f738d7',
				title: 'Points for Your Wedding Reception Music Contract',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding musician playing trumpet',
				href: `${tkHost}/content/wedding-reception-music-contract-points`,
			},
		],
	},
	BEA: {
		categoryLink: `${tkHost}/content/wedding-beauty-advice`,
		articles: [
			{
				srcId: '4edbbf6a-3921-4f62-ae88-891f51062a36',
				title: '10 Questions to Ask Your Wedding Hairstylist',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'bride hairstyle',
				href: `${tkHost}/content/questions-to-ask-your-hairstylist`,
			},
			{
				srcId: '13e8fc6b-ad34-4976-b31d-2890fbbbf0fe',
				title: '8 Important Questions You Should Ask a Makeup Artist',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'wedding day makeup',
				href: `${tkHost}/content/questions-to-ask-makeup-artists`,
			},
			{
				srcId: '03e2c14e-8932-4a00-a066-9d7cf6e3e14c',
				title: '5 Ways to Prep for Your Hair and Makeup Trial',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: '5 Ways to Prep for Your Hair and Makeup Trial',
				href: `${tkHost}/content/prep-for-hair-and-makeup-trial`,
			},
		],
	},
	BWP: {
		categoryLink: `${tkHost}/content/wedding-dress-advice`,
		articles: [
			{
				srcId: '6039ddd3-6147-44e5-8e56-a713cf263757',
				title: '10 Things to Know Before You Go Wedding Dress Shopping',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Bride with mother trying on wedding dress',
				href: `${tkHost}/content/top-dress-shopping-secrets`,
			},
			{
				srcId: 'c23e1136-ccb0-4078-808f-eadeba6d4e4d',
				title: "Don't Buy Your Wedding Dress Without Asking These Questions",
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Mismatched Bridesmaid Dresses in Red, Orange and Pink',
				href: `${tkHost}/content/questions-to-ask-bridal-consultant`,
			},
			{
				srcId: '04a620d7-fc96-4272-9a95-795f1825864b',
				title:
					'5 Things Bridal Salon Owners Want You to Know Before Wedding Dress Shopping',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding dresses',
				href: `${tkHost}/content/things-bridal-salon-owners-want-you-to-know`,
			},
		],
	},
	CAT: {
		categoryLink: `${tkHost}/content/wedding-catering-advice`,
		articles: [
			{
				srcId: '4c932ec4-deb2-4ec3-aaca-e925177a1256',
				title: 'How to Start Your Search for a Caterer',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding Entre',
				href: `${tkHost}/content/finding-a-good-wedding-caterer`,
			},
			{
				srcId: 'ff80bcb0-5e63-4137-a2ad-d8cf2638bc00',
				title: 'Questions to Ask Your Wedding Caterer',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: "Wedding catering tray with hors d'oeuvres",
				href: `${tkHost}/content/questions-to-ask-your-wedding-caterer`,
			},
			{
				srcId: '8251696d-f8bf-4275-8b7c-139ca050c834',
				title: 'Points for Your Wedding Catering Contract',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Food for dinner',
				href: `${tkHost}/content/wedding-catering-contract`,
			},
		],
	},
	DJS: {
		categoryLink: `${tkHost}/content/wedding-music-advice`,
		articles: [
			{
				srcId: '9d4327e0-5305-4877-a5c9-c85a6135c5d8',
				title: 'Should You Have a Band or DJ for Your Wedding Reception Music?',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding reception Band and DJ',
				href: `${tkHost}/content/wedding-reception-music-bands-vs-djs`,
			},
			{
				srcId: '9d15ff84-dbe5-40ee-898a-70e909906771',
				title: '22 Questions to Ask Your Wedding Band or DJ',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding band performs at reception',
				href: `${tkHost}/content/wedding-reception-music-questions-to-ask-a-band`,
			},
			{
				srcId: 'eea9b5a5-6400-44e1-bd70-5d1a83748b96',
				title: '10 Most Common Myths About Wedding Music',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Brass wedding band',
				href: `${tkHost}/content/top-10-wedding-music-myths`,
			},
		],
	},
	FLO: {
		categoryLink: `${tkHost}/content/wedding-advice`,
		articles: [
			{
				srcId: '0479eacc-2f12-41e2-b1f1-cbc4e2bfb9f8',
				title: '8 Steps to Finding Your Florist',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: '8 steps to finding your florist',
				href: `${tkHost}/content/steps-to-finding-wedding-florist`,
			},
			{
				srcId: '2640d308-01ad-4f80-b1b2-2ac1a38b179b',
				title: '10 Questions to Ask Before Hiring Your Florist',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Bridesmaid holding a bouquet',
				href: `${tkHost}/content/wedding-florist-questions-before-hiring`,
			},
			{
				srcId: '3afd959d-41c6-4348-99d3-f4820b184b03',
				title: 'The Complete Guide to Your Floral Contract, Decoded',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Reception centerpiece in wood box with lavender place setting',
				href: `${tkHost}/content/wedding-flower-contract-proposal`,
			},
		],
	},
	PLN: {
		categoryLink: `${tkHost}/wedding-planning`,
		articles: [
			{
				srcId: '720312fc-cb0d-4e73-9398-0ee2707f0da5',
				title: 'What Type of Wedding Planner Do You Need?',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding set in a bar venue',
				href: `${tkHost}/content/about-wedding-planners`,
			},
			{
				srcId: 'a8c546a1-618a-4a0f-a1ab-966c3989362b',
				title:
					"Yes, There Are Different Types of Wedding Planners—Here's What You Need to Know",
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'modern, colorful wedding backdrop',
				href: `${tkHost}/content/types-of-wedding-planners`,
			},
			{
				srcId: '8075141b-466c-4492-9839-fa363c28be8e',
				title: 'Follow These 5 Steps to Hiring a Wedding Planner',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Hawaiian reception dinner',
				href: `${tkHost}/content/how-to-hire-a-wedding-planner`,
			},
		],
	},
	REC: {
		categoryLink: `${tkHost}/content/wedding-advice`,
		articles: [
			{
				srcId: '50deacb7-4ea3-4dd1-8997-b9603798f8bf',
				title: 'Exactly What to Look for in a Wedding Reception Venue',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Modern Farmhouse Venue',
				href: `${tkHost}/content/finding-a-wedding-reception-location`,
			},
			{
				srcId: '9f82d433-c10e-4130-a640-eb8659b8b221',
				title: 'Questions to Ask on Your Wedding Venue Site Tour',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Wedding ceremony',
				href: `${tkHost}/content/wedding-venue-site-tour-questions-to-ask`,
			},
			{
				srcId: '3cd1116e-0e35-4059-865e-018e20e8236c',
				title: '16 Questions to Ask Your Destination Wedding Venue',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Destination wedding beach ceremony',
				href: `${tkHost}/content/destination-wedding-venue-questions`,
			},
		],
	},
	VID: {
		categoryLink: `${tkHost}/wedding-photography-videography`,
		articles: [
			{
				srcId: '8f111626-128e-49a9-921a-c9fd21551435',
				title: 'What You Should Know Before You Book Your Videographer',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Couple making a heart with their hands',
				href: `${tkHost}/content/wedding-videography-getting-started`,
			},
			{
				srcId: 'f8966754-f28a-475c-a30c-402497dcb33d',
				title: 'How to Get The Best Wedding Video Ever',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Ring bearers and flower girls throwing rose petals',
				href: `${tkHost}/content/finding-a-good-wedding-videographer`,
			},
			{
				srcId: '6fa15c0a-5215-40e7-9694-3d0df0e88adf',
				title:
					"If You're on the Fence About Getting a Wedding Videographer, Read This",
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Bride and groom with wedding party',
				href: `${tkHost}/content/why-not-to-cut-wedding-videography`,
			},
		],
	},
	WPH: {
		categoryLink: `${tkHost}/wedding-photography-videography`,
		articles: [
			{
				srcId: '0584d723-a65c-4396-96ca-d2210156220b',
				title: '10 Steps to Finding a Great Wedding Photographer',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Hawaiian Bride and Groom',
				href: `${tkHost}/content/wedding-photography-getting-started`,
			},
			{
				srcId: 'ec2766ba-7004-4d26-992d-0e5cbfc49a0d',
				title: 'Important Questions to Ask Photographers Before You Book',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: 'Black and white exit photography',
				href: `${tkHost}/content/questions-to-ask-wedding-photographer`,
			},
			{
				srcId: 'd619d4a0-20db-4c43-802f-eb9a7ad19a0c',
				title: 'Points for Your Wedding Photography Contract',
				dek: "These are the essentials you won't want to be without (trust us).",
				alt: "Modern bride and groom couple's photo",
				href: `${tkHost}/content/wedding-photography-contract-essentials`,
			},
		],
	},
};
